import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//

export default {
  name: 'Watermark',
  computed: {
    visible: function visible() {
      // 只在有token且不是登录页时显示
      return this.$store.state.user.token && this.$route.path !== '/login';
    },
    watermarkText: function watermarkText() {
      console.log('使用当前登录账号作为水印内容', this.$store.state.user);
      // 使用当前登录账号作为水印内容
      //   this.$store.state.user.account只取后四位
      var account = this.$store.state.user.account.slice(-4);
      return this.$store.state.user.name + ' @DabHands ' + account;
    },
    watermarkStyle: function watermarkStyle() {
      return {
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='14' fill='rgba(107, 106, 106, 0.1)' text-anchor='middle' transform='rotate(-45 100 100)'%3E".concat(encodeURIComponent(this.watermarkText), "%3C/text%3E%3C/svg%3E\")")
      };
    }
  }
};